module.exports = __webpack_public_path__ + "static/example_1_day-f0a3690a4134e86b5f0b4770c511d957.png";